var map = {
	"./Steve-Jobs.svg": "./src/assets/icons/svg/Steve-Jobs.svg",
	"./alipay.svg": "./src/assets/icons/svg/alipay.svg",
	"./anq.svg": "./src/assets/icons/svg/anq.svg",
	"./app.svg": "./src/assets/icons/svg/app.svg",
	"./backup.svg": "./src/assets/icons/svg/backup.svg",
	"./chain.svg": "./src/assets/icons/svg/chain.svg",
	"./chart.svg": "./src/assets/icons/svg/chart.svg",
	"./codeConsole.svg": "./src/assets/icons/svg/codeConsole.svg",
	"./dashboard.svg": "./src/assets/icons/svg/dashboard.svg",
	"./database.svg": "./src/assets/icons/svg/database.svg",
	"./date.svg": "./src/assets/icons/svg/date.svg",
	"./deploy.svg": "./src/assets/icons/svg/deploy.svg",
	"./dept.svg": "./src/assets/icons/svg/dept.svg",
	"./dev.svg": "./src/assets/icons/svg/dev.svg",
	"./develop.svg": "./src/assets/icons/svg/develop.svg",
	"./dictionary.svg": "./src/assets/icons/svg/dictionary.svg",
	"./doc.svg": "./src/assets/icons/svg/doc.svg",
	"./download.svg": "./src/assets/icons/svg/download.svg",
	"./edit.svg": "./src/assets/icons/svg/edit.svg",
	"./education.svg": "./src/assets/icons/svg/education.svg",
	"./email.svg": "./src/assets/icons/svg/email.svg",
	"./error.svg": "./src/assets/icons/svg/error.svg",
	"./exit-fullscreen.svg": "./src/assets/icons/svg/exit-fullscreen.svg",
	"./fullscreen.svg": "./src/assets/icons/svg/fullscreen.svg",
	"./fwb.svg": "./src/assets/icons/svg/fwb.svg",
	"./github.svg": "./src/assets/icons/svg/github.svg",
	"./gonggao.svg": "./src/assets/icons/svg/gonggao.svg",
	"./icon.svg": "./src/assets/icons/svg/icon.svg",
	"./image.svg": "./src/assets/icons/svg/image.svg",
	"./index.svg": "./src/assets/icons/svg/index.svg",
	"./international.svg": "./src/assets/icons/svg/international.svg",
	"./ipvisits.svg": "./src/assets/icons/svg/ipvisits.svg",
	"./java.svg": "./src/assets/icons/svg/java.svg",
	"./link.svg": "./src/assets/icons/svg/link.svg",
	"./list.svg": "./src/assets/icons/svg/list.svg",
	"./lock.svg": "./src/assets/icons/svg/lock.svg",
	"./log.svg": "./src/assets/icons/svg/log.svg",
	"./login.svg": "./src/assets/icons/svg/login.svg",
	"./markdown.svg": "./src/assets/icons/svg/markdown.svg",
	"./menu.svg": "./src/assets/icons/svg/menu.svg",
	"./message.svg": "./src/assets/icons/svg/message.svg",
	"./mnt.svg": "./src/assets/icons/svg/mnt.svg",
	"./money.svg": "./src/assets/icons/svg/money.svg",
	"./monitor.svg": "./src/assets/icons/svg/monitor.svg",
	"./nested.svg": "./src/assets/icons/svg/nested.svg",
	"./password.svg": "./src/assets/icons/svg/password.svg",
	"./people.svg": "./src/assets/icons/svg/people.svg",
	"./peoples.svg": "./src/assets/icons/svg/peoples.svg",
	"./permission.svg": "./src/assets/icons/svg/permission.svg",
	"./phone.svg": "./src/assets/icons/svg/phone.svg",
	"./qiniu.svg": "./src/assets/icons/svg/qiniu.svg",
	"./redis.svg": "./src/assets/icons/svg/redis.svg",
	"./role.svg": "./src/assets/icons/svg/role.svg",
	"./search.svg": "./src/assets/icons/svg/search.svg",
	"./server.svg": "./src/assets/icons/svg/server.svg",
	"./shopping.svg": "./src/assets/icons/svg/shopping.svg",
	"./size.svg": "./src/assets/icons/svg/size.svg",
	"./skill.svg": "./src/assets/icons/svg/skill.svg",
	"./source.svg": "./src/assets/icons/svg/source.svg",
	"./sqlMonitor.svg": "./src/assets/icons/svg/sqlMonitor.svg",
	"./swagger.svg": "./src/assets/icons/svg/swagger.svg",
	"./sys-tools.svg": "./src/assets/icons/svg/sys-tools.svg",
	"./system.svg": "./src/assets/icons/svg/system.svg",
	"./system1.svg": "./src/assets/icons/svg/system1.svg",
	"./tab.svg": "./src/assets/icons/svg/tab.svg",
	"./theme.svg": "./src/assets/icons/svg/theme.svg",
	"./timing.svg": "./src/assets/icons/svg/timing.svg",
	"./tools.svg": "./src/assets/icons/svg/tools.svg",
	"./tree-table.svg": "./src/assets/icons/svg/tree-table.svg",
	"./tree.svg": "./src/assets/icons/svg/tree.svg",
	"./unlock.svg": "./src/assets/icons/svg/unlock.svg",
	"./user.svg": "./src/assets/icons/svg/user.svg",
	"./user1.svg": "./src/assets/icons/svg/user1.svg",
	"./validCode.svg": "./src/assets/icons/svg/validCode.svg",
	"./visits.svg": "./src/assets/icons/svg/visits.svg",
	"./web.svg": "./src/assets/icons/svg/web.svg",
	"./wechat.svg": "./src/assets/icons/svg/wechat.svg",
	"./weixin.svg": "./src/assets/icons/svg/weixin.svg",
	"./zujian.svg": "./src/assets/icons/svg/zujian.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";